<app-expansion-panel-without-border
  [titre]="phase().nom"
  [item]="phase()"
  [actions]="peutModifier() ? phasesActions : []"
  [cdkDragData]="phase()"
  [cdkDragDisabled]="!peutModifier()"
  [draggable]="peutModifier()"
  [mustBeOpen]="hasOneAptitudeSelected()"
  cdkDrag
>
  <div ngProjectAs="etat">
    <app-chip [label]="aptitudeLabel()" />
  </div>
  <div class="ml-md gap-md flex flex-col">
    <div
      class="flex flex-col"
      [id]="'aptitudes-phase-' + phase().id"
      [cdkDropListConnectedTo]="aptitudesIdsPhases()"
      [cdkDropListData]="phase().aptitudes | filtrerPar: 'idPhase' : phase().id"
      (cdkDropListDropped)="dropAptitude($event, phase().id)"
      cdkDropList
    >
      @for (aptitude of phase().aptitudes | trierPar: 'indice'; track aptitude.id) {
        <app-item-aptitude-processus
          [aptitude]="aptitude"
          [peutModifier]="peutModifier()"
          [referentiel]="referentiel()"
          [cartographie]="cartographie()"
          [phases]="phases()"
          (onCreateIndiceResultat)="onCreateIndiceResultat.emit($event)"
          (onCreateProduction)="onCreateProduction.emit($event)"
        />
      } @empty {
        <span class="paragraph-medium-medium text-content-secondary">Aucune aptitude n'a été créée.</span>
      }
    </div>
    @if (peutModifier()) {
      <button (click)="ajoutAptitude(phase())" hlmBtn variant="secondary">
        <ng-icon name="lucidePlus"></ng-icon>Ajouter une aptitude
      </button>
    }
  </div>
</app-expansion-panel-without-border>
